import axios from "axios";
import { useContext, useEffect, useReducer, useState } from "react";
import { Store } from "../Store";
import { getError } from "../utils";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "FETCH_FAIL":
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default function useSampleProductsAndCategories() {
  const { dispatch: ctxDispatch, state } = useContext(Store);
  const { userInfo, products, categories, leafCategories } = state;
  const [{ loading, error }, dispatch] = useReducer(reducer, {
    loading: false,
    error: "",
  });

  const [loadProducts, setLoadProducts] = useState(false);
  const [loadCategories, setLoadCategories] = useState(false);
  const [loadLeafCategories, setLoadLeafCategories] = useState(false);

  const fetchProducts = async () => {
    try {
      dispatch({ type: "FETCH_REQUEST", payload: {} });
      const { data } = await axios.get(`/api/productsamples`, {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      });

      dispatch({ type: "FETCH_SUCCESS" });
      ctxDispatch({
        type: "PRODUCTS_UPDATED",
        payload: { products: data || [], mostUsedProducts: [] },
      });
    } catch (err) {
      dispatch({ type: "FETCH_FAIL", payload: getError(err) });
    }
  };

  const fetchCategories = async () => {
    try {
      dispatch({ type: "FETCH_REQUEST", payload: {} });
      const { data } = await axios.get(
        `/api/categorysamples/withProductsAndSubCategories`,
        {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
          },
        }
      );

      dispatch({ type: "FETCH_SUCCESS" });
      ctxDispatch({
        type: "CATEGORIES_UPDATED",
        payload: data || { categories: [], allCategories: [] },
      });
    } catch (err) {
      dispatch({ type: "FETCH_FAIL", payload: getError(err) });
    }
  };

  const fetchLeafCategories = async () => {
    try {
      const { data } = await axios.get(
        `/api/categorysamples/leafes/compartment`,
        {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
          },
        }
      );
      ctxDispatch({
        type: "LEAF_CATEGORIES_UPDATED",
        payload: data || [],
      });
    } catch (err) {}
  };

  useEffect(() => {
    if (userInfo.isHelpDesk && !userInfo.client && !products) {
      fetchProducts();
    }
  }, [userInfo]);

  useEffect(() => {
    if (userInfo.isHelpDesk && !userInfo.client && !categories) {
      fetchCategories();
    }
  }, [userInfo]);

  useEffect(() => {
    if (userInfo.isHelpDesk && !userInfo.client && !leafCategories) {
      fetchLeafCategories();
    }
  }, [userInfo]);

  useEffect(() => {
    if (userInfo.isHelpDesk && !userInfo.client && loadProducts) {
      fetchProducts();
      setLoadProducts(false);
    }
  }, [loadProducts]);

  useEffect(() => {
    if (userInfo.isHelpDesk && !userInfo.client && loadCategories) {
      fetchCategories();
      setLoadCategories(false);
    }
  }, [loadCategories]);

  useEffect(() => {
    if (userInfo.isHelpDesk && !userInfo.client && loadLeafCategories) {
      fetchLeafCategories();
      setLoadLeafCategories(false);
    }
  }, [loadLeafCategories]);

  return [
    loading,
    error,
    setLoadProducts,
    setLoadCategories,
    setLoadLeafCategories,
  ];
}
